import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement
} from "react";
import styles from "./ActionList.module.less";

export type ActionListProps = {
	width?: "auto" | "fill" | "max";
	trackingId?: string;
};

export const ActionList = (props: PropsWithChildren<ActionListProps>): ReactElement => {
	const {
		width = "auto",
		trackingId,
		children
	} = props;

	return (
		<ul
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{
					[styles.root_fill]: width === "fill",
					[styles.root_max]: width === "max"
				}
			)}
		>
			{ children }
		</ul>
	);
};
ActionList.displayName = "ActionList";
